import AlphaLevelFacade from '@app/core/facades/alpha-level.facade';
import AlphaYearFacade from '@app/core/facades/alpha-year.facade';
import MapPercentageFacade from '@app/core/facades/map-percentage.facade';
import { SubjectFacade } from '@app/core/facades/subject.facade';
import { FilterConfiguration } from 'app/shared/filters/filter-config.model';
import { FilterOptions } from 'app/shared/filters/filter-options.interface';
import { FilterType } from '../components/sub-header/filter-type.model';

export const kendoFilterUtility = (isDisabled: boolean, config: FilterConfiguration): FilterOptions => {
  if (isDisabled) {
    return { value: config.disabledLabel, label: config.disabledLabel };
  } else if (config?.allowAll?.enabled) {
    return { value: 'ALL', label: config?.allowAll?.label };
  }
  return null;
};

export const resetKendoFilters = (data: {
  facade: { reset?: () => void; setFilters: (value: []) => void };
  level: AlphaLevelFacade;
  subject: SubjectFacade;
  mapPercentage: MapPercentageFacade;
  yearsAtAlpha: AlphaYearFacade;
}) => {
  data.facade.reset();
  FilterType.Level.configure({
    allowAll: {
      enabled: false,
      init: () => data.level.enableAll(false),
    },
  });
  FilterType.MapPercentage.configure({
    allowAll: {
      enabled: false,
      init: () => data.mapPercentage.enableAll(false),
    },
  });
  FilterType.YearAtAlpha.configure({
    allowAll: {
      enabled: false,
      init: () => data.yearsAtAlpha.enableAll(false),
    },
  });
  FilterType.Subject.configure({
    allowAll: {
      enabled: false,
      init: () => data.subject.enableAll(false),
    },
  });

  data.facade.setFilters([]);
};
